import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Emit, Component, Mixins } from 'vue-property-decorator';

/* TODO: Make this component more general use */
/**
 * Component used to show only the amount of links that are possible to put
 * on one row. Emits any elements that are not able to fit so they can be displayed
 * with other methods (eg. in a dropdown).
 */
var CollapsibleRowComponent = /** @class */ (function (_super) {
    __extends(CollapsibleRowComponent, _super);
    function CollapsibleRowComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.usedWidth = '100%';
        _this.hiddenIndexes = [];
        _this.skipResize = true;
        _this.isChecking = false;
        _this.resizeObserver = null;
        return _this;
    }
    CollapsibleRowComponent.prototype.mounted = function () {
        var _this = this;
        // @ts-ignore
        this.resizeObserver = new ResizeObserver(function () {
            _this.checkVisibilityChange();
        });
        // Wait for element to be mounted into parent (as web components are mounted first detached from DOM)
        this.$nextTick().then(function () {
            var host = _this.$el.getRootNode().host;
            _this.resizeObserver.observe(
            // Try to use the 'most accurate' element for detecting resizes.
            // most cases this is the parent but if that doesn't exist we fallback.
            host.parentElement || host);
            _this.checkVisibilityChange();
        });
    };
    CollapsibleRowComponent.prototype.destroyed = function () {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    };
    CollapsibleRowComponent.prototype.onItemsChange = function () {
        this.checkVisibilityChange();
    };
    CollapsibleRowComponent.prototype.itemRefs = function () {
        var refs = this.$refs.item;
        if (!refs || !Array.isArray(refs) || !(refs[0] instanceof Element)) {
            return [];
        }
        return refs;
    };
    /**
     * This method:
     * - Resets all hidden items back to be an empty list
     * - Resets all available space to be 100% of it's parent
     * - Checks how many items we can fit on a row and applies a hidden class if they overflow on to a new line
     * - If the previous hidden items are different to the 'new' hidden items then we try checking once more
     *
     * This method has to check twice each time as the action of emitting hidden items could cause a layout change
     * @param emitEmptyList Determines whether to initially emit an empty list to reset the component display
     *                      entirely (eg. from external factors like a dropdown next to the component)
     */
    CollapsibleRowComponent.prototype.checkVisibilityChange = function (emitEmptyList, allowRecursion) {
        if (emitEmptyList === void 0) { emitEmptyList = true; }
        if (allowRecursion === void 0) { allowRecursion = true; }
        return __awaiter(this, void 0, void 0, function () {
            var oldHiddenIndexes, itemRefs, contWidth, index, usedWidth, hiddenItems, hiddenIndexes, _i, itemRefs_1, item, width, currentWidth;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isChecking) {
                            // Immediately resolve as we have something else checking currently.
                            return [2 /*return*/];
                        }
                        if (!this.shouldNotHideItems) return [3 /*break*/, 2];
                        this.emitHidden([]);
                        return [4 /*yield*/, this.resetHiddenComponents()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2:
                        oldHiddenIndexes = this.hiddenIndexes;
                        itemRefs = this.itemRefs();
                        if (itemRefs.length === 0) {
                            this.emitHidden([]);
                            return [2 /*return*/];
                        }
                        this.isChecking = true;
                        // Remove any additional items caused by hidden items if needed
                        if (emitEmptyList) {
                            this.emitHidden([]);
                        }
                        // Reset the component width
                        return [4 /*yield*/, this.resetHiddenComponents()];
                    case 3:
                        // Reset the component width
                        _a.sent();
                        contWidth = this.$el.getRootNode().host.getBoundingClientRect().width;
                        index = 0;
                        usedWidth = 0;
                        hiddenItems = [];
                        hiddenIndexes = [];
                        for (_i = 0, itemRefs_1 = itemRefs; _i < itemRefs_1.length; _i++) {
                            item = itemRefs_1[_i];
                            width = item.getBoundingClientRect().width;
                            currentWidth = width + usedWidth;
                            if (currentWidth > contWidth) {
                                hiddenItems.push(this.items[index]);
                                hiddenIndexes.push(index);
                            }
                            else {
                                usedWidth = currentWidth;
                            }
                            index++;
                        }
                        this.emitHidden(hiddenItems);
                        this.usedWidth = usedWidth + 'px';
                        this.hiddenIndexes = hiddenIndexes;
                        if (!(hiddenIndexes.length !== oldHiddenIndexes.length ||
                            !hiddenIndexes.every(function (item) { return oldHiddenIndexes.includes(item); }))) return [3 /*break*/, 5];
                        // Layout once more to consider new adjustments due to newly hidden items
                        return [4 /*yield*/, this.$nextTick()];
                    case 4:
                        // Layout once more to consider new adjustments due to newly hidden items
                        _a.sent();
                        this.isChecking = false;
                        // prevent infinite recursion
                        if (allowRecursion) {
                            this.checkVisibilityChange(hiddenIndexes.length === 0, false);
                        }
                        return [2 /*return*/];
                    case 5:
                        this.isChecking = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    CollapsibleRowComponent.prototype.resetHiddenComponents = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.usedWidth = '100%';
                        this.hiddenIndexes = [];
                        return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CollapsibleRowComponent.prototype.emitHidden = function (items) {
        return items;
    };
    CollapsibleRowComponent.prototype.onItemClick = function (slug) {
        return slug;
    };
    __decorate([
        Prop(Array),
        __metadata("design:type", Array)
    ], CollapsibleRowComponent.prototype, "items", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], CollapsibleRowComponent.prototype, "activeItem", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], CollapsibleRowComponent.prototype, "left", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], CollapsibleRowComponent.prototype, "right", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], CollapsibleRowComponent.prototype, "shouldNotHideItems", void 0);
    __decorate([
        Watch('items', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CollapsibleRowComponent.prototype, "onItemsChange", null);
    __decorate([
        Emit('hidden'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], CollapsibleRowComponent.prototype, "emitHidden", null);
    __decorate([
        Emit('item-click'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], CollapsibleRowComponent.prototype, "onItemClick", null);
    CollapsibleRowComponent = __decorate([
        Component({
            name: 'ui-collapsible-row',
        })
    ], CollapsibleRowComponent);
    return CollapsibleRowComponent;
}(Mixins(MagicConfigMixin)));

export default CollapsibleRowComponent;
